/**
 * External dependencies
 */
import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createGlobalReducer } from '@naruto/naruto-reducers/src/reducers/global';
import { createMessageReducer } from '@naruto/naruto-reducers/src/reducers/message';

/**
 * Internal dependencies
 */
import { createUserReducer } from '@naruto/bgdapp/src/reducers/cores/user';
import { createProjectReducer } from '@naruto/bgdapp/src/reducers/cores/project';
import { createServiceReducer } from '@naruto/bgdapp/src/reducers/cores/service';
import { createContactReducer } from '@naruto/bgdapp/src/reducers/cores/contact';
import { createSiteMetaReducer } from '@naruto/bgdapp/src/reducers/cores/site-meta';
import { CreateStoreParams, Store } from './types';

function initializeStore(params: CreateStoreParams): Store {
  const { initialModel, initialMiddleWare } = params;
  return reduxCreateStore(
    combineReducers({
      global: createGlobalReducer({
        initialState: initialModel.global
      }),
      message: createMessageReducer({
        initialState: initialModel.message
      }),
      user: createUserReducer({
        initialState: initialModel.user
      }),
      project: createProjectReducer({
        initialState: initialModel.project
      }),
      service: createServiceReducer({
        initialState: initialModel.service
      }),
      contact: createContactReducer({
        initialState: initialModel.contact
      }),
      siteMeta: createSiteMetaReducer({
        initialState: initialModel.siteMeta
      })
    }),
    applyMiddleware(thunk.withExtraArgument({ ...initialMiddleWare }))
  );
}

export default initializeStore;
